export interface User {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  role?: UserRole;
  organization?: number;
  adminOrganizationIds?: number[];
}

export enum UserRole {
  User = 'user',
  Annotator = 'annotator',
  OrgAdmin = 'org_admin',
  SuperAdmin = 'super_admin',
}

export interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  loading: boolean;
}
